import React from "react";
import { observer } from "mobx-react";
import Literal from "./Literal";

const NumberEditor = ({
  title = "",
  value,
  required,
  viewonly = false,
  viewframe = true,
  updatefunc,
  repattern = "^-{0,1}\\d+$",
}) => {
  const onChange = (e) => {
    let re = new RegExp(repattern);
    if (re.test(e.target.value) || e.target.value === "") {
      if (e.target.value.length < 450) {
        updatefunc(e.target.value);
      } else {
        updatefunc(e.target.value.substr(0, 449));
      }
    } else {
      updatefunc(value);
    }
  };

  let css = "sn-ctrl sn-ctrl-text";
  if (value === "" && required) {
    css = css + " sn-ctrl-req";
  }

  return (
    <React.Fragment>
      {!viewonly && viewframe && (
        <div className="input-field">
          <label>{title}</label>
          <div>
            <input
              data-cy={"NumberEdit_" + title.replace(/ /g, "_")}
              type="text"
              value={value}
              onChange={onChange}
              className={css}
              autoComplete="off"
            />
          </div>
        </div>
      )}
      {!viewonly && !viewframe && (
        <input
          data-cy={"NumberEdit_" + title.replace(/ /g, "_")}
          type="text"
          value={value}
          onChange={onChange}
          className={css}
          autoComplete="off"
        />
      )}
      {viewonly && <Literal title={title} text={value} />}
    </React.Fragment>
  );
};

export default observer(NumberEditor);
